module.exports = __webpack_public_path__ + "img/Shilpa Architects.b03f395b.jpg";